var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-pagination',{staticClass:"custom-table-pagination",attrs:{"pills":"","total-rows":_vm.total,"per-page":_vm.perPageNum},model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }